import { ScrollTrigger, gsap } from '../LibrariesImport';
import { GlobalVariables } from '../GlobalVariables';

export default class HomePage {
	static init() {
		if (!document.body.classList.contains('page-template-template-home')) {
			return;
		}

		this.initScrollIndicator();

		/** @type HTMLAnchorElement */
		this.bannerBtnEl = document.querySelector('.banner .cta-wrapper .has-btn a');
		this.formSectionEl = document.querySelector('.section:has(form)');

		if (this.bannerBtnEl && this.formSectionEl) {
			this.initStickyScrollToForm();
		}
	}

	static initScrollIndicator() {
		const scrollIndicatorEls = document.querySelectorAll('.scroll-indicator');

		if (!scrollIndicatorEls.length) {
			return;
		}

		scrollIndicatorEls.forEach((scrollIndicatorEl) => {
			const scrollTargetEl = scrollIndicatorEl.closest('section').nextElementSibling;

			scrollIndicatorEl.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				GlobalVariables.smoother.scrollTo(scrollTargetEl, true);
			});
		});
	}

	static initStickyScrollToForm() {
		if (this.bannerBtnEl.getAttribute('href') !== "#") {
			return;
		}

		this.bannerBtnEl.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			GlobalVariables.smoother.scrollTo(this.formSectionEl, true);
		});

		ScrollTrigger.create({
			trigger: '.banner',
			pin: this.bannerBtnEl,
			pinSpacing: false,
			start: 'bottom bottom',
			endTrigger: this.formSectionEl,
			end: 'top bottom',
			onLeave: () => {
				gsap.to(this.bannerBtnEl, { opacity: 0, pointerEvents: 'none' });
			},
			onEnterBack: () => {
				gsap.to(this.bannerBtnEl, { opacity: 1, pointerEvents: 'initial' });
			},
		});
	}
}